export class IndustryCompany {
  constructor(private fiscalNumber: string, private corporateName: string, private tradingName: string) {}

  public getFiscalNumber(): string {
    return this.fiscalNumber;
  }

  public getCorporateName(): string {
    return this.corporateName;
  }

  public getTradingName(): string {
    return this.tradingName;
  }

  public setFiscalNumber(value: string) {
    this.fiscalNumber = value;
  }

  public setCorporateName(value: string) {
    this.corporateName = value;
  }

  public setTradingName(value: string) {
    this.tradingName = value;
  }
}
